Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.ReviewQueueFiltersView extends Backbone.View
  template: JST["backbone/templates/monitoring/review_queue_filters"]

  initialize: (@options = {}) ->
    @socialContentCondition = @options.socialContentCondition
    @availableTopics = @options.topics || []
    @tagsByClientCode = @options.tagsByClientCode || []
    @availableSubtypes = @options.availableSubtypes || []
    @allSubtypes = @options.allSubtypes || []

  destroy: ->
    @remove()
    return false

  render: ->
    @$el.html(@template(conditionsAsText: @_conditionsAsText()))
    return @

  # TODO: Esto es porque no existe un modelo SocialContentCondition.
  _conditionsAsText: ->
    helper = new Monitoring.Views.ReviewQueueDefinitionListView
      availableTopics: @availableTopics
      availableTags: @tagsByClientCode
      availableSubtypes: @availableSubtypes
      allSubtypes: @allSubtypes
    definition = new Monitoring.Models.ReviewQueueDefinition
      social_content_condition: @socialContentCondition
    defaultConditions =
      "<b>#{I18n.t('monitoring.rules.fields.topics')}</b>:
          #{I18n.t('monitoring.dashboard.all_topics')}"
    helper.getConditionsAsText(definition) || defaultConditions
